import { useEffect, useId, useState } from 'react';
import { useApp } from '../../../../hook/app.hook';
import { Question, Section } from '../../../../response/test.response';
import { RichInput } from '../../../../view/editor/rich.input';
import { getLanguageContent } from '../../../../util/language.util';

const LongAnsComponent = () => {
  const { testRes, saveQuestionResponse, language } = useApp();
  const id = useId();
  const question = testRes.sectionList
    .filter((section: Section) => section.active)[0]
    .questionList.filter((question: Question, index: number) => {
      return question.active;
    })[0];

  const [answer, setAnswer] = useState(
    getLanguageContent(question.candidateAnswer, language) ?? '',
  );

  useEffect(() => {
    if (answer && answer.length > 0) {
      saveQuestionResponse(question.id, answer, null);
    }
  }, [answer]);

  useEffect(() => {
    setAnswer(getLanguageContent(question.candidateAnswer, language) ?? '');
  }, [question.id, language]);

  return (
    <div
      key={id}
      className="custom-ckeditor--edit-view border border-light-blue rounded pb-2 px-2 mb-2"
    >
      <p>Answer</p>
      <RichInput
        key={`ck_view_${id}`}
        initData={answer}
        placeholder={'Write answer here'}
        onChange={(data: string) => {
          setAnswer(data);
        }}
      />
    </div>
  );
};

export default LongAnsComponent;
